<template>
    <div>
        <div class="form-row">
            <div class="col col-12 col-md-3">
                <div class="list-group overflow-auto" style="height: 65vh;">
                    <a href="#" class="list-group-item list-group-item-action" 
                        :class="iix == selecionado ? 'active' : ''" @click.prevent="selecionar(item, iix)"
                        v-for="(item, iix) in items" :key="iix">
                        {{ item.titulo }}
                    </a>
                </div>
            </div>
            <div class="col col-12 col-md-9">
                <div class="card overflow-auto" style="height: 65vh;">
                    <div class="card-body">
                        <pre>{{ conteudo }}</pre>
                        <pre>{{ items }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() { 
        return { 
            items: [],
            conteudo: null, 
            selecionado: null, 
        };
    },

    methods: { 
        selecionar(item, index) { 
            this.selecionado = index;
            this.conteudo = item;
        }
    },

    mounted() { 
        for (let index = 0; index < 50; index++) {
            this.items.push({
                id: index,
                titulo: 'Item ' + index,
                conteudo: 'Algo sobre ' + index, 
            });
        }
    }
}
</script>
